/* Temporary solution. We should revisit this on NI v2.
   Layouts should be defined per route and not have path logics. 
   E.g. We might need to create separate layouts/flows for new Subscription
   and for Subscription Checkout Update.
*/

// We show the simple header if we are in the new subscription checkout flow.
// When subscription is an update, we show regular header.
export function shouldHaveSimpleHeader(
  pathname: string,
  isSubscriptionAnUpdate: boolean | undefined | null,
) {
  if (isSubscriptionAnUpdate === null || isSubscriptionAnUpdate === undefined)
    return;

  const paths = [
    '/subscription/checkout/account/',
    '/subscription/checkout/address/',
    '/subscription/checkout/payment/',
    '/subscription/checkout/success/',
  ];

  return (
    paths.some((path) => {
      return pathname.includes(path);
    }) && !isSubscriptionAnUpdate
  );
}

// Only shown in address and payment steps of the new subscription checkout flow.
export function shouldShowStepper(
  pathname: string,
  isSubscriptionAnUpdate: boolean | undefined | null,
) {
  if (isSubscriptionAnUpdate === null || isSubscriptionAnUpdate === undefined)
    return;

  const paths = [
    '/subscription/checkout/address/',
    '/subscription/checkout/payment/',
  ];

  return (
    paths.some((path) => {
      return pathname.includes(path);
    }) && !isSubscriptionAnUpdate
  );
}
